import React, {useState, KeyboardEvent, useRef, FC} from 'react'
import './CustomTagInput.scss'

interface Props {
  value: string | null
  name: string
  placeholder?: string
  onChange: (e: any) => void
}

const CustomTagInput: FC<Props> = ({value, name, placeholder, onChange}) => {
  const [inputValue, setInputValue] = useState('')
  const inputRef = useRef<HTMLInputElement>(null)

  const tags = value ? value.split(';').filter((t) => t.trim() !== '') : []

  const updateValue = (newTags: string[]) => {
    const fakeEvent = {
      target: {
        name,
        value: newTags.join(';'),
      },
    }
    onChange(fakeEvent)
  }

  const addTag = (tag: string) => {
    const trimmedTag = tag.trim()
    if (trimmedTag && !tags.includes(trimmedTag)) {
      updateValue([...tags, trimmedTag])
    }
    setInputValue('')
  }

  const removeTag = (index: number) => {
    const newTags = [...tags]
    newTags.splice(index, 1)
    updateValue(newTags)
  }

  const handleKeyDown = (e: KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Enter' || e.key === ';' || e.key === 'Tab') {
      e.preventDefault()
      addTag(inputValue)
    } else if (e.key === 'Backspace' && !inputValue && tags.length > 0) {
      removeTag(tags.length - 1)
    }
  }

  const handleContainerClick = () => {
    inputRef.current?.focus()
  }

  return (
    <div className='custom-tag-input-container' onClick={handleContainerClick}>
      {tags.map((tag, index) => (
        <div key={index} className='tag-item'>
          {tag}
          <span
            className='tag-remove'
            onClick={(e) => {
              e.stopPropagation()
              removeTag(index)
            }}
          >
            &times;
          </span>
        </div>
      ))}
      <input
        ref={inputRef}
        type='text'
        className='tag-input'
        placeholder={tags.length === 0 ? placeholder : ''}
        value={inputValue}
        onChange={(e) => setInputValue(e.target.value)}
        onKeyDown={handleKeyDown}
        onBlur={() => {
          if (inputValue) addTag(inputValue)
        }}
      />
    </div>
  )
}

export default CustomTagInput
